// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonGoBackWhite_button__TiXsV"};